import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const inboxApi = createApi({
  reducerPath: 'inboxApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
  tagTypes: ['Inbox'],
  endpoints: builder => ({
    fetchInboxes: builder.query<any[], string>({
      query: (category: string) => ({
        url: '/users/inboxes',
        method: 'GET',
        params: {
          category,
        },
      }),
      providesTags: ['Inbox'],
      keepUnusedDataFor: 600,
    }),
    deleteInboxes: builder.mutation<{ message: string }, string[]>({
      query: (ids: string[]) => ({
        url: '/users/inboxes',
        method: 'DELETE',
        body: {
          ids,
        },
      }),
      invalidatesTags: ['Inbox'],
    }),
    readInbox: builder.mutation<{ message: string }, string>({
      query: (id: string) => ({
        url: '/users/inboxes',
        method: 'POST',
        body: {
          id,
        },
      }),
      invalidatesTags: ['Inbox'],
    }),
  }),
});

export const {
  useFetchInboxesQuery,
  useLazyFetchInboxesQuery,
  useDeleteInboxesMutation,
  useReadInboxMutation,
} = inboxApi;
